<div class="layout-footer">
    Powered by
    <a href="https://arco.com.py" target="_blank" rel="noopener noreferrer"
        class="text-primary font-bold hover:underline"><span>&copy;
            {{year}} ARCO Systems</span> </a>
</div>